import React from "react";
import { useTranslation } from "../i18n/TranslationProvider";

import { Col, Row, Form } from "react-bootstrap";

const TimeInput = ({ label, register, errors, className, disableStatus, checked }) => {
  const { t } = useTranslation();
  return (
    <Row className={className} style={{ padding: "0px 15px 15px 15px" }}>
      <Form.Label
        as="h6"
        style={{ width: "100%", margin: "10px 0px 20px 0px" }}
      >
        {label}
      </Form.Label>
      <Form.Group controlId="dayOfWeek">
        {[
          { label: t("onboarding.notifPrefs.dayOfWeek.mon"), name: "monday" },
          { label: t("onboarding.notifPrefs.dayOfWeek.tue"), name: "tuesday" },
          { label: t("onboarding.notifPrefs.dayOfWeek.wed"), name: "wednesday" },
          { label: t("onboarding.notifPrefs.dayOfWeek.thu"), name: "thursday" },
          { label: t("onboarding.notifPrefs.dayOfWeek.fri"), name: "friday" },
          { label: t("onboarding.notifPrefs.dayOfWeek.sat"), name: "saturday" },
          { label: t("onboarding.notifPrefs.dayOfWeek.sun"), name: "sunday" },
        ].map((day) => (
          <Form.Check
            inline
            label={day.label}
            type="checkbox"
            name={day.name}
            id={day.name}
            ref={register}
            defaultChecked={checked}
            disabled={disableStatus}
            key={day.name}
            style={{ margin: "0 0.5rem" }}
          />
        ))}
        {errors.dayofweek && (
          <Form.Control.Feedback style={{ display: "block" }} type="invalid">
            {errors.dayofweek.message}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Row style={{ width: "100%" }}>
        <Col xs={5} md={4}>
          <Form.Control
            placeholder="HH"
            type="number"
            ref={register}
            name="hour"
            aria-label={t("onboarding.timeInput.hour")}
            isInvalid={errors.hour}
            disabled={disableStatus}
          />
        </Col>
        <Col xs={5} md={4}>
          <Form.Control
            as="select"
            aria-label={t("onboarding.timeInput.partOfDay")}
            ref={register}
            name="partOfDay"
            isInvalid={errors.partOfDay}
            disabled={disableStatus}
          >
            <option value="AM">AM</option>
            <option value="PM">PM</option>
          </Form.Control>
        </Col>
      </Row>
      {errors.hour && (
        <Form.Control.Feedback
          // display set to block to override display:none
          style={{ display: "block" }}
          type="invalid"
        >
          {errors.hour.message}
        </Form.Control.Feedback>
      )}
    </Row>
  );
};

export default TimeInput;